<script>import { onDestroy, SvelteComponent } from "svelte";
import { customFade } from "../FloatingUI/transitions";
import { get_current_component } from "svelte/internal";
import { twJoin } from "tailwind-merge";
export let left;
export let right;
export let top;
export let bottom;
export let autoDismiss = void 0;
export let props;
export let component;
export let id;
export let store;
export let stayOnScreen = false;
export let shadow = true;
let element;
let timer = autoDismiss ? setTimeout(() => {
  $store = null;
}, autoDismiss) : null;
const thisComponent = get_current_component();
let internal_timer;
$:
  isActive = $store === id;
$: {
  if (!isActive) {
    internal_timer = setTimeout(() => {
      thisComponent.$destroy();
    }, 1e3);
  } else {
    clearTimeout(internal_timer);
  }
}
function renderComponentOnScreen() {
  let windowHeight = window.innerHeight;
  let adjustedOffsetY = top, adjustedOffsetX;
  const element2 = document.getElementById(id);
  if (element2 && element2.getBoundingClientRect().bottom > windowHeight) {
    adjustedOffsetY = adjustedOffsetY - element2.offsetHeight;
  }
  adjustedOffsetX = left ?? right;
  return {
    adjustedOffsetX,
    adjustedOffsetY
  };
}
function resetTimer() {
  if (autoDismiss) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      $store = null;
    }, autoDismiss);
  }
}
$: {
  if (isActive) {
    resetTimer();
  }
}
onDestroy(() => {
  if (timer) {
    clearTimeout(timer);
  }
});
</script>

{#if isActive}
	<div
		bind:this={element}
		transition:customFade={{ duration: 150, beforeRender: stayOnScreen ? renderComponentOnScreen : null }}
		class={twJoin("absolute z-[9000]", shadow && "shadow-lg")}
		style={`left: ${left !== undefined ? left + "px" : "auto"};
        top: ${top !== undefined ? top + "px" : "auto"};
        right: ${right !== undefined ? right + "px" : "auto"};
        bottom: ${bottom !== undefined ? bottom + "px" : "auto"};`}
	>
		<svelte:component this={component} id={id} {...props} />
	</div>
{/if}
